<template>
	<modal class="modal-notice-export-modal" :size="'medium'" :hide-footer="true" @close="close">
		<div slot="header">
			<h3>Export Order</h3>
		</div>
		<div slot="body">
            <div class="alert alert-danger d-flex">
				<span>Export Order hanya bisa dilakukan <b>maksimum 90 Hari.</b> Saat ini filter terhitung <b>{{ diffInDays }} Hari</b>. Silahkan ubah filter tanggal untuk melanjutkan.</span>
            </div>
			<div class="text-bold my-2">
				Filter Tanggal Saat Ini
			</div>
			<div class="d-flex align-items-center">
				<div class="alert alert-warning w-100 mr-1">
					<b>Tanggal Mulai</b>
					<div>
						{{ since }}
					</div>
				</div>
				<div class="alert alert-warning w-100 ml-1">
					<b>Tanggal Selesai</b>
					<div>
						{{ until }}
					</div>
				</div>
			</div>
			<div slot="footer" class="d-flex justify-content-end">
				<button class="btn btn-light" @click="close">
					Close
				</button>
			</div>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalNoticeExport',
	components: {
		Modal,
	},
	props: {
		filterDate: {
			type: Object,
			default: null,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		since() {
			return this.moment(this.filterDate.start).format('DD-MM-YYYY');
		},
		until() {
			return this.moment(this.filterDate.end).format('DD-MM-YYYY');
		},
		diffInDays() {
			const since = this.moment(this.filterDate.start);
			const until = this.moment(this.filterDate.end);
			return until.diff(since, 'days');
		},
	},
};
</script>
